
define('template!companiesDetailBodySubaccountRowView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td class="sel"><input type="checkbox" class="js-select" ' +
((__t = ( selected ? 'checked' : '' )) == null ? '' : __t) +
'/></td>\n<td class="code">' +
((__t = ( endUserId )) == null ? '' : __t) +
'</td>\n<td class="name">' +
((__t = ( name )) == null ? '' : __t) +
'</td>\n<td class="first-name">' +
((__t = ( firstName )) == null ? '' : __t) +
'</td>\n<td class="last-name">' +
((__t = ( lastName )) == null ? '' : __t) +
'</td>\n<td class="email">' +
((__t = ( email )) == null ? '' : __t) +
'</td>\n<td class="city">' +
((__t = ( city )) == null ? '' : __t) +
'</td>\n';

}
return __p
};});

